import React, { useState } from 'react';
import confetti from 'canvas-confetti';
interface SignupModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function SignupModal({
  isOpen,
  onClose
}: SignupModalProps) {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim() === '') return;
    // Here you would typically send the email to your backend
    setIsSubmitted(true);
    // Trigger confetti
    confetti({
      particleCount: 100,
      spread: 70,
      origin: {
        y: 0.6
      },
      colors: ['#F587A0', '#F8B396', '#FF9B7A']
    });
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-charcoal-900/60 backdrop-blur-md flex items-center justify-center z-50 p-4" data-id="element-248">
      <div className="bg-white dark:bg-charcoal-800 rounded-3xl max-w-lg w-full p-8 relative border border-charcoal-100 dark:border-charcoal-700" onClick={e => e.stopPropagation()} data-id="element-249">
        <button onClick={onClose} className="absolute top-4 right-4 text-charcoal-400 dark:text-charcoal-400 hover:text-charcoal-500 dark:hover:text-white transition-colors" data-id="element-250">
          ✕
        </button>
        {!isSubmitted ? <div data-id="element-251">
            <h2 className="text-2xl md:text-3xl font-light mb-4 text-charcoal-500 dark:text-white" data-id="element-252">
              join our{' '}
              <span className="bg-gradient-coral bg-clip-text text-transparent" data-id="element-253">
                waitlist
              </span>
            </h2>
            <p className="text-charcoal-400 dark:text-charcoal-300 mb-8" data-id="element-254">
              Be among the first to experience caltalk and receive exclusive
              early access benefits.
            </p>
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-255">
              <div data-id="element-256">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your email" className="w-full px-4 py-3 bg-cream-100 dark:bg-charcoal-700 text-charcoal-500 dark:text-white rounded-lg border border-transparent focus:border-coral-500 dark:focus:border-coral-400 focus:outline-none transition-colors" required data-id="element-257" />
              </div>
              <button type="submit" className="w-full px-6 py-3 bg-gradient-coral text-white font-light rounded-full hover:bg-gradient-coral-hover transition-all group relative overflow-hidden shadow-lg hover:shadow-xl hover:shadow-coral-500/20" data-id="element-258">
                <span className="relative z-10" data-id="element-259">join waitlist</span>
              </button>
            </form>
          </div> : <div className="text-center py-6" data-id="element-260">
            <div className="w-16 h-16 rounded-full bg-coral-500/10 dark:bg-coral-400/10 flex items-center justify-center mx-auto mb-6" data-id="element-261">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-262">
                <path d="M20 6L9 17L4 12" stroke="#F587A0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-263" />
              </svg>
            </div>
            <h2 className="text-2xl font-light mb-4 text-charcoal-500 dark:text-white" data-id="element-264">
              thank you for joining
            </h2>
            <p className="text-charcoal-400 dark:text-charcoal-300 mb-8" data-id="element-265">
              We'll notify you when caltalk is ready for early access. Stay
              tuned for updates.
            </p>
            <button onClick={onClose} className="px-6 py-3 bg-coral-500/10 dark:bg-coral-400/10 text-coral-600 dark:text-coral-400 font-light rounded-full hover:bg-coral-500/20 dark:hover:bg-coral-400/20 transition-all" data-id="element-266">
              close
            </button>
          </div>}
      </div>
    </div>;
}